import React from 'react';
import { Alert, Button, Form, FormControl, FormGroup, InputGroup, Modal, Row, Col } from 'react-bootstrap';
import ValidatedField from '../Validation/ValidatedField';
import Api from '../../api/api';
import Validator from '../Validation/Validator';

class EditEmailModal extends React.Component {
  state = {
    errors: [],
    alternateEmail: this.props.email,
    alert: {
      type: 'success',
      text: '',
    },
    emailWasEdited: false,
  };

  componentDidUpdate(): void {
    const alert = document.getElementById('emailConfirmAlert');
    const alertMsg = this.state.alert;

    if (alert && alertMsg.type !== 'danger') {
      setTimeout((): void => {
        alert.style.display = 'none';
        this.setAlert();
      }, 5000);
    }
  }

  validator = new Validator({
    alternateEmail: [Validator.required, Validator.email],
  });

  handleAlternateEmailChange = (event: SyntheticInputEvent<HTMLInputElement>): void => {
    if (this.state.emailWasEdited) {
      return this.setState({ alternateEmail: event.target.value });
    }

    return this.setState({ alternateEmail: event.target.value, emailWasEdited: true });
  };

  setAlert = (type = '', text = '') => {
    this.setState({ alert: { type, text } });
  };

  handleSubmitAlternateEmail = (e: SyntheticEvent<HTMLButtonElement>): void => {
    e.preventDefault();

    this.setState({ errors: [] }, () => {
      const alternateEmail = this.state.emailWasEdited ? this.state.alternateEmail : this.props.email;

      const errors = this.validator.validate({ alternateEmail });

      if (errors.length) {
        this.setState({ errors });
      } else {
        Api.users
          .changeVerificationEmail(alternateEmail)
          .then(() => {
            this.setAlert('success', 'Verification link successfully resent');
          })
          .catch(error => {
            const {
              response: { statusText, data },
            } = error;

            if (data && data.email) {
              this.setState({ errors: [...this.state.errors, { field: 'alternateEmail', message: data.email }] });
            } else {
              this.setAlert('danger', `An error has occured. The link was not resent`);
            }
          });
      }
    });
  };

  render() {
    const { show, email } = this.props;
    const {
      errors,
      alternateEmail,
      alert: { text },
      emailWasEdited,
    } = this.state;

    return (
      <Modal show={show} className="show-grid-in are-not-finished">
        {text && (
          <Alert id="emailConfirmAlert" bsStyle="success" onDismiss={this.setAlert}>
            <span className="png-ok-circle" />
            <span className="text-alert">{text}</span>
          </Alert>
        )}
        <Modal.Header>
          <Modal.Title>
            Attention:<br />You are not finished!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You must verify your email to start your account. You will receive<br /> a verification link sent to:
          </p>
          <Form onSubmit={this.handleSubmitAlternateEmail}>
            <FormGroup>
              <InputGroup className="fields-modal">
                <Row>
                  <Col md={12}>
                    <ValidatedField field="alternateEmail" errors={errors}>
                      <FormControl
                        className="field-email"
                        id="alternateEmail"
                        type="text"
                        placeholder="Alternate Email"
                        onChange={this.handleAlternateEmailChange}
                        value={emailWasEdited ? alternateEmail : email}
                      />
                    </ValidatedField>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} />
                  <Col md={6}>
                    <InputGroup.Button className="field-input">
                      <Button className="save-and-resend-input" type="submit" bsStyle="primary">
                        Resend Link
                      </Button>
                    </InputGroup.Button>
                  </Col>
                </Row>
              </InputGroup>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

export default EditEmailModal;



// WEBPACK FOOTER //
// ./src/components/Register/EditEmail.js